import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Fade, Zoom } from "react-awesome-reveal";
import { Helmet } from "react-helmet-async";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { BookingForm } from "../components/BookingForm";
// import { BookingFormGroup } from "../components/cruiseBooking/BookingFormGroup";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
// import "swiper/swiper-bundle.min.css";
import { DatePicker, Drawer, CustomProvider } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { format } from "date-fns";
import { enUS, fr, es, it, de, zhCN } from "date-fns/locale";
import {
  enUS as enUSRsuite,
  frFR,
  esES,
  itIT,
  deDE,
  zhCN as zhCNRsuite,
} from "rsuite/locales";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDoubleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  Alert,
  Snackbar,
  styled,
  Tooltip,
  tooltipClasses,
  useMediaQuery,
} from "@mui/material";
import { fetchCruiseListBooking } from "../data/groupBooking/cruiseListSlice";
import Loader from "../Loader";
import { BrandColorContext } from "../App";
import { useTranslation } from "react-i18next";

const cursorStyle = {
  cursor: `url('/ship-wheel-white.svg') 25 25, auto`, // 25 25 represents the cursor hotspot position
};
// CruiseLocationId,
// CruiseTypeIds,
// CruiseBrandIds,
// CruiseRatingName,
// SearchInput,
export const BookingFormListing = () => {
  const { t, i18n } = useTranslation();
  const language = useSelector((state) => state.language.language);
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width:768px) and (max-width:1023px)");
  const isDesktop = useMediaQuery("(min-width:1024px)");
  const brandColor = useContext(BrandColorContext);
  const { configuration } = useSelector((state) => state.configuration);
  // You can also use them in combination
  const isSmallScreen = useMediaQuery("(max-width:1023px)"); // Both mobile and tablet

  // Map language codes to date-fns locales
  const dateLocales = {
    en: enUS,
    fr: fr,
    es: es,
    it: it,
    de: de,
    cn: zhCN, // Chinese locale
  };

  // Map language codes to rsuite locales
  const rsuiteLocales = {
    en: enUSRsuite,
    fr: frFR,
    es: esES,
    it: itIT,
    de: deDE,
    cn: zhCNRsuite, // Chinese locale
  };

  const currentDateLocale = dateLocales[language || "en"] || enUS;
  const currentRsuiteLocale = rsuiteLocales[language || "en"] || enUSRsuite;

  const cursorStyle = {
    cursor: `url('/ship-wheel-white.svg') 25 25, auto`, // 25 25 represents the cursor hotspot position
  };
  const navigate = useNavigate();
  const { durations, loading, error } = useSelector((state) => state.durations);
  const { cruisesListBooking, loadingCruisesList, errorCruisesList } =
    useSelector((state) => state.cruisesListBooking);

  // Replace static locations with durations data
  const locations =
    durations?.map((duration) => ({
      name: duration?.durationFullName,
      durationDay: duration.durationNights,
      description: t("common.nileCruise"),
      dates: duration.operationDates,
      durationStartId: duration.durationStartDestId,
      durationEndId: duration.durationEndDestId,
    })) || [];
  const [isActiveDestination, setIsActiveDestination] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const durationDayParams = queryParams.get("durationDay");
  const [durationDay, setDurationDay] = useState(durationDayParams);
  const chainCode = queryParams.get("chainCode");
  const operationDate = queryParams.get("operationDate");

  const startDestId = queryParams.get("startDestId");
  const endDestId = queryParams.get("endDestId");
  const numCabins = queryParams.get("numCabins");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    new Date(operationDate) || ""
  );
  const [selectedDurationStartId, setSelectedDurationStartId] = useState(0);
  const [selectedDurationEndId, setSelectedDurationEndId] = useState(0);
  useEffect(() => {
    if (
      cruisesListBooking?.cruisesGeneralData?.durationFullName ||
      cruisesListBooking?.request?.startDestId ||
      cruisesListBooking?.request?.endDestId
    ) {
      setSelectedLocation(
        cruisesListBooking?.cruisesGeneralData?.durationFullName
      );
      setSelectedDurationStartId(cruisesListBooking?.request?.startDestId);
      setSelectedDurationEndId(cruisesListBooking?.request?.endDestId);

      // Also populate selectedDates from durations data so the DatePicker shows available dates
      if (durations?.length > 0) {
        const matchingDuration = durations.find(
          (d) =>
            d.durationStartDestId === cruisesListBooking?.request?.startDestId &&
            d.durationEndDestId === cruisesListBooking?.request?.endDestId
        );
        if (matchingDuration?.operationDates) {
          const availableDates = matchingDuration.operationDates
            .map((date) => new Date(date.dateString))
            .sort((a, b) => a - b);
          setSelectedDates(availableDates);
        }
      }
    }
  }, [
    cruisesListBooking?.cruisesGeneralData?.durationFullName,
    cruisesListBooking?.request?.endDestId,
    cruisesListBooking?.request?.startDestId,
    durations,
  ]);

  const [selectedDates, setSelectedDates] = useState([]); // Add this to track available dates
  // Update handleLocationSelect to also set available dates
  const handleLocationSelect = (location) => {
    setSelectedLocation(location.name);
    setDurationDay(location.durationDay);
    setSelectedDurationStartId(location.durationStartId); // Add this line
    setSelectedDurationEndId(location.durationEndId); // Add this line
    // Convert all dates to Date objects and sort them
    const availableDates = location.dates
      .map((date) => new Date(date.dateString))
      .sort((a, b) => a - b);
    setSelectedDates(availableDates);
    // Find the first date that's after today
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const firstAvailableDate = availableDates.find((date) => date >= today);
    setSelectedDate(firstAvailableDate || null);
    setSearchTerm("");
    setIsActiveDestination(false);
  };
  const disabledDate = (date) => {
    const today = new Date();
    if (date < today.setHours(0, 0, 0, 0)) return true;

    // If no duration selected, disable all dates
    if (!selectedLocation) return true;

    // Check if date is in available dates
    return !selectedDates.some(
      (availableDate) => availableDate.toDateString() === date.toDateString()
    );
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const searchMenuRef = useRef(null);

  // Toggle the active state on click
  const handleDestinationClick = () => {
    setIsActiveDestination(!isActiveDestination);
  };

  // Handle blur event
  const handleBlur = (event) => {
    if (
      searchMenuRef.current &&
      !searchMenuRef.current.contains(event.relatedTarget)
    ) {
      setIsActiveDestination(false);
    }
  };

  // Filter locations based on search term
  const filteredLocations = locations.filter((location) =>
    location.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const dispatch = useDispatch();
  // const { cruisesListBooking, loadingCruisesList, errorCruisesList } =
  //   useSelector((state) => state.cruisesListBooking);

  const [roomData, setRoomData] = useState(() => {
    const initialCabins = [];
    const initialNumCabins = parseInt(numCabins, 10) || 1;
    for (let i = 1; i <= initialNumCabins; i++) {
      const adults = parseInt(queryParams.get(`adults_room_${i}`), 10) || 1;
      const children = parseInt(queryParams.get(`children_room_${i}`), 10) || 0;
      const childrenAgesParam = queryParams.get(`childAges_room_${i}`);
      const childrenAges =
        childrenAgesParam &&
        childrenAgesParam !== "undefined" &&
        childrenAgesParam !== "null"
          ? childrenAgesParam.split(",").filter(Boolean).map(Number)
          : [];
      initialCabins.push({ cabinNumber: i, adults, children, childrenAges });
    }
    return initialCabins;
  });
  const handleRoomsChange = (newRoomCount) => {
    setRoomData((prevData) => {
      const updated = [...prevData];
      while (updated.length < newRoomCount) {
        updated.push({ adults: 1, children: 0, childAges: [] });
      }
      return updated.slice(0, newRoomCount);
    });
  };

  const updateRoomAdults = (index, value) => {
    setRoomData((prev) =>
      prev.map((room, i) =>
        i === index
          ? {
              ...room,
              adults: Math.max(
                1,
                Math.min(3 - room.children, room.adults + value)
              ),
            }
          : room
      )
    );
  };

  const updateRoomChildren = (index, value) => {
    setRoomData((prev) =>
      prev.map((room, i) => {
        if (i !== index) return room;
        const newChild = room.children + value;
        const currentChildAges = room.childAges || []; // Ensure childAges is an array
        const maxChildren = 3 - room.adults;
        return {
          ...room,
          children: Math.max(0, Math.min(maxChildren, newChild)),
          childAges:
            newChild > currentChildAges.length
              ? [
                  ...currentChildAges,
                  ...Array(newChild - currentChildAges.length).fill(2),
                ]
              : currentChildAges.slice(0, newChild),
        };
      })
    );
  };

  const handleAgeChange = (roomIndex, childIndex, newAge) => {
    setRoomData((prev) =>
      prev.map((room, i) =>
        i === roomIndex
          ? {
              ...room,
              childAges: room.childAges.map((age, j) =>
                j === childIndex ? newAge : age
              ),
            }
          : room
      )
    );
  };

  // Add new function to handle age changes
  const totalAdults = roomData.reduce((acc, room) => acc + room.adults, 0);
  const totalChildren = roomData.reduce((acc, room) => acc + room.children, 0);
  const [adults, setAdults] = useState(totalAdults);
  const [children, setChildren] = useState(totalChildren);

  const handleDecrement = (setter) => {
    setter((prev) => (prev > 0 ? prev - 1 : 0));
  };

  const [isActiveGuest, setIsActiveGuest] = useState(false);

  const GuestMenuRef = useRef(null);

  // Toggle the active state on click
  const handleGuestClick = () => {
    setIsActiveGuest(!isActiveGuest);
  };
  const handleGuestBlur = (event) => {
    if (
      GuestMenuRef.current &&
      !GuestMenuRef.current.contains(event.relatedTarget)
    ) {
      setIsActiveGuest(false);
    }
  };
  const formatDate = (date) => {
    if (!date) return "";
    return format(date, "EEE d MMM", { locale: currentDateLocale }); // e.g., "Wed 2 Mar"
  };
  const disablePastDates = (date) => {
    const today = new Date();
    return date < today.setHours(0, 0, 0, 0); // Disable past dates
  };
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error"); // 'error' | 'warning' | 'info' | 'success'
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const currentUrl = new URL(window.location.href);
  const queryString = new URLSearchParams(currentUrl.search);

  const handleSearch = async () => {
    setIsLoading(true);
    if (!selectedDurationStartId || !selectedDurationEndId || !selectedDate) {
      setSnackbarMessage(t("common.pleaseSelectDuration"));
      setSnackbarSeverity("warning");
      setOpenSnackbar(true);
      setIsLoading(false);
      return;
    }
    const dateToFormat = new Date(selectedDate);
    if (isNaN(dateToFormat.getTime())) {
      setSnackbarMessage(t("common.invalidDateSelected"));
      setSnackbarSeverity("error");
      setOpenSnackbar(true);

      return;
    }

    const formattedDate = format(dateToFormat, "dd-MM-yyyy", {
      locale: currentDateLocale,
    });

    const payload = {
      // chainCode,
      operationDate: formattedDate,
      durationDay,
      startDestId: selectedDurationStartId,
      endDestId: selectedDurationEndId,
      numCabins: roomData.length,
      cabins: roomData.map((room, index) => ({
        cabinNumber: index + 1,
        adults: room.adults,
        children: room.children,
        childrenAges: room.children > 0 ? room.childrenAges : [0],
      })),
    };
    // Create query string from payload
    const queryStringParams = {
      chainCode,
      operationDate: payload.operationDate,
      durationDay: payload.durationDay,
      startDestId: payload.startDestId,
      endDestId: payload.endDestId,
      numCabins: roomData.length,
    };

    roomData?.forEach((room, index) => {
      queryStringParams[`adults_room_${index + 1}`] = room.adults;
      queryStringParams[`children_room_${index + 1}`] = room.children;
      queryStringParams[`childAges_room_${index + 1}`] =
        room?.childAges?.join(",");
    });

    const queryString = new URLSearchParams(queryStringParams).toString();

    try {
      const resultAction = await dispatch(
        fetchCruiseListBooking({
          payload,
          chainCode,
          language: language || "en",
        })
      );
      if (fetchCruiseListBooking.fulfilled.match(resultAction)) {
        // setSnackbarMessage(`Search On ${selectedLocation}...`);
        // setSnackbarSeverity("success");
        // setOpenSnackbar(true);
        localStorage.setItem("selectedLocationName", selectedLocation);
        setIsLoading(false);
        // setTimeout(() => navigate(`/booking-cruises?${queryString}`), 0);
        navigate(`/booking-cruises?lang=en&${queryString}`);
      } else {
        throw new Error(resultAction.error.message);
      }
    } catch (err) {
      setSnackbarMessage(
        err.message || t("common.errorOccurredWhileSearching")
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      setIsLoading(false);
    }
  };
  const [drawerOpen, setDrawerOpen] = useState(false);
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "#c80101",
      boxShadow: theme.shadows[1],
      fontSize: 12,
    },
  }));
  return (
    <>
      <Helmet>
        <style>{`
          @media (max-width: 1023px) {
            .searchMenu-guests__field.-is-active.listing {
              position: fixed !important;
              left: 2.5% !important;
              top: 50% !important;
              transform: translateY(-50%) !important;
              width: 95% !important;
              min-width: unset !important;
              z-index: 9999 !important;
              max-height: 80vh;
              overflow-y: auto;
            }
            .searchMenu-loc__field.-is-active {
              position: fixed !important;
              left: 2.5% !important;
              width: 95% !important;
              z-index: 9999 !important;
            }
          }
          .rs-picker-popup.rs-picker-popup-date{z-index:99}
          `}</style>
      </Helmet>
      <div className="tabs -underline my-3 js-tabs is-in-view">
        <div className="tabs__content  js-tabs-content">
          <h4
            className="text-primary pb-10 mb-30"
            style={{ borderBottom: "2px solid #eee" }}
          >
            {t("common.search")}:{" "}
          </h4>
          <div className="tabs__pane -tab-item-1 is-tab-el-active">
            <div className="mainSearch -w-1000 bg-white px-10  lg:px-20 lg:pt-5 lg:pb-20 rounded-100">
              <div className="button-grid items-center d-flex flex-column">
                <div
                  ref={searchMenuRef}
                  className={`searchMenu-loc   js-form-dd js-liverSearch border  ${
                    isActiveDestination ? "-is-dd-wrap-active" : ""
                  }`}
                  style={{
                    padding: "0 0 10px 0",
                    width: "100%",

                    borderTop: "0px solid #eee",
                    borderRight: "0px solid #eee",
                    borderLeft: "0px solid #eee",
                    borderBottom: "2px solid #eee",
                  }}
                  onClick={handleDestinationClick}
                >
                  <div onBlur={handleBlur} data-x-dd-click="searchMenu-loc">
                    <h4 className="text-15 fw-500 ls-2 lh-16">
                      {t("common.whereWouldLikeToGo")}
                    </h4>
                    <div className="text-15 text-light-1 ls-2 lh-16 d-flex justify-between">
                      <input
                        autoComplete="off"
                        type="search"
                        placeholder={t("common.select")}
                        className="js-search js-dd-focus w-auto"
                        value={selectedLocation} // Set the input value to the selected location
                        onChange={(e) => {
                          setSelectedLocation(e.target.value);
                          setSearchTerm(e.target.value); // Update search term to filter results
                        }}
                      />
                      <FontAwesomeIcon
                        className="text-primary"
                        onClick={() =>
                          setIsActiveDestination(!isActiveDestination)
                        }
                        // className="mx-2 my-1"

                        icon={isActiveDestination ? faAngleUp : faAngleRight}
                      />
                    </div>
                  </div>

                  <div
                    className={`searchMenu-loc__field shadow-2 js-popup-window ${
                      isActiveDestination ? "-is-active" : ""
                    }`}
                    data-x-dd="searchMenu-loc"
                    data-x-dd-toggle="-is-active"
                  >
                    <div className="bg-white px-30 py-15 sm:px-0 sm:py-15 rounded-4">
                      <div className="y-gap-5 js-results">
                        {loadingCruisesList ? (
                          <Fragment>
                            <img
                              src="/ship-wheel.svg"
                              alt="Loading..."
                              className="spinning-wheel d-block m-auto"
                            />
                            <p className="text-center m-auto">
                              {t("common.loading")}
                            </p>
                          </Fragment>
                        ) : filteredLocations.length > 0 ? (
                          filteredLocations.map((location, index) => (
                            <div
                              key={location.name}
                              style={{
                                margin: 0,
                                border: 0,
                                borderBottom:
                                  index + 1 != filteredLocations.length &&
                                  "1px solid #ddd",
                                padding: 0,
                              }}
                            >
                              <button
                                className="-link d-block col-12 text-left rounded-4 px-0 py-15 js-search-option"
                                onClick={() => handleLocationSelect(location)}
                              >
                                <div className="d-flex">
                                  <div className=" icon-destination text-light-1 text-20 pt-4"></div>

                                  <div className="ml-10">
                                    <div className="text-15 lh-12 fw-500">
                                      {location.name}
                                    </div>
                                    <div className="text-14 lh-12 text-light-1 mt-5">
                                      {/* {location.description} */}
                                    </div>
                                  </div>
                                </div>
                              </button>
                            </div>
                          ))
                        ) : (
                          <div className="text-center py-15">
                            {t("common.noResults")}
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="bg-white  py-1 "
                      style={{
                        borderBottom: `4px solid ${brandColor}`,
                        height: "auto",

                        overflow: "hidden",
                      }}
                    >
                      {" "}
                      <Button
                        className="mx-auto   pt-2 text-center d-block"
                        onClick={() => setIsActiveDestination(false)}
                      >
                        <FontAwesomeIcon
                          className="mx-2 my-1"
                          icon={faAngleDoubleUp}
                        />
                      </Button>
                    </div>
                  </div>
                </div>
                <div
                  className="searchMenu-date   -is-dd-wrap-active w-100"
                  style={{
                    padding: "30px 0 10px 0",
                    width: "100%",

                    marginBottom: "30px",
                    border: "0",

                    borderBottom: "2px solid #eee",
                  }}
                >
                  <div>
                    <h4 className="text-15 fw-500 ls-2 lh-16">
                      {t("common.departsAsEarlyAs")}
                    </h4>
                    <CustomProvider
                      key={language || "en"}
                      locale={currentRsuiteLocale}
                    >
                      <DatePicker
                        value={selectedDate}
                        onChange={handleDateChange}
                        placeholder={
                          selectedLocation
                            ? t("common.selectDate")
                            : t("common.selectDurationFirst")
                        }
                        format="dd-MM-yyyy"
                        className="text-15 text-light-1 ls-2 lh-16"
                        shouldDisableDate={disabledDate}
                        disabled={!selectedLocation}
                        renderValue={(value) => {
                          return format(value, "EEE, d MMM", {
                            locale: currentDateLocale,
                          });
                        }}
                        oneTap
                      />
                    </CustomProvider>
                  </div>
                </div>
                <div
                  ref={GuestMenuRef}
                  className={`searchMenu-guests  w-100 mb-3 js-form-dd js-form-counters   ${
                    isActiveGuest ? "-is-dd-wrap-active" : ""
                  }`}
                  style={{
                    padding: "0 0 10px 0",
                    width: "100%",

                    borderTop: "0px solid #eee",
                    borderRight: "0px solid #eee",
                    borderLeft: "0px solid #eee",
                    borderBottom: "2px solid #eee",
                  }}
                  onBlur={handleGuestBlur}
                >
                  <div
                    data-x-dd-click="searchMenu-guests"
                    onClick={handleGuestClick}
                  >
                    <h4 className="text-15 fw-500 ls-2 lh-16 text-left">
                      {t("common.guest")}
                    </h4>
                    <div
                      className="text-14 text-light-1 ls-2 lh-16 d-flex align-items-center justify-content-between"
                      style={{ cursor: "pointer" }}
                    >
                      <div>
                        {" "}
                        <span className="js-count-room">
                          {roomData.length}
                        </span>{" "}
                        {roomData.length > 1
                          ? t("booking.cabins")
                          : t("booking.cabins").slice(0, -1)}{" "}
                        - <span className="js-count-adult">{totalAdults}</span>{" "}
                        {t("common.adults")} -{" "}
                        <span className="js-count-child">{totalChildren}</span>{" "}
                        {t("common.children")}{" "}
                      </div>
                      <FontAwesomeIcon
                        className="text-primary ps-2"
                        onClick={() => setIsActiveGuest(!isActiveGuest)}
                        style={{ float: "right" }}
                        // className="mx-2 my-1"
                        icon={isActiveGuest ? faAngleUp : faAngleRight}
                      />
                    </div>{" "}
                  </div>

                  <div
                    style={
                      isSmallScreen
                        ? {
                            position: "fixed",
                            left: "2.5%",
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "95%",
                            zIndex: 9999,
                            maxHeight: "80vh",
                            overflowY: "auto",
                          }
                        : { left: "100%", transform: "unset" }
                    }
                    className={`searchMenu-guests__field shadow-2 listing  ${
                      isActiveGuest ? "-is-active" : ""
                    }`}
                  >
                    {/* Close button at the top */}
                    <div
                      className="bg-white p-2  "
                      style={{
                        borderTop: `4px solid ${brandColor}`,
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                        backgroundColor: "white",
                      }}
                    >
                      <Button
                        className="ms-auto  py-2 text-center d-block  btn-danger"
                        onClick={() => setIsActiveGuest(false)}
                      >
                        <FontAwesomeIcon className="mx-2 my-1" icon={faTimes} />
                      </Button>
                      {/* <Button
                        className="mx-auto py-1 text-center d-block"
                        onClick={() => setIsActiveGuest(false)}
                        style={{ background: "transparent", border: "none" }}
                      >
                        <FontAwesomeIcon
                          className="mx-2 my-1 text-primary"
                          icon={faTimes}
                          style={{ fontSize: "20px" }}
                        />
                      </Button> */}
                    </div>
                    <div className="bg-white px-10 py-20 rounded-4">
                      <div className="row y-gap-10 justify-between items-center">
                        <div className="col-auto">
                          <div className="text-15 fw-500">
                            {t("common.cabinsSuites")}
                          </div>
                        </div>

                        <div className="col-auto">
                          <div className="d-flex items-center justify-content-between js-counter">
                            <button
                              className="button -outline-blue-1 text-blue-1 size-38 rounded-4 js-down"
                              onClick={() =>
                                handleRoomsChange(
                                  Math.max(1, roomData.length - 1)
                                )
                              }
                            >
                              <i className="icon-minus text-12"></i>
                            </button>

                            <div className="flex-center size-20 ml-15 mr-15">
                              <div className="text-15">{roomData.length}</div>
                            </div>

                            <button
                              className="button -outline-blue-1 text-blue-1 size-38 rounded-4 js-up"
                              onClick={() =>
                                handleRoomsChange(
                                  Math.min(3, roomData.length + 1)
                                )
                              }
                            >
                              <i className="icon-plus text-12"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="border-top-light mt-10 mb-10"></div>
                      <div className="d-flex mobile">
                        {" "}
                        {roomData.map((room, index) => (
                          <div
                            key={index}
                            className="p-4 mx-2"
                            style={{
                              border: "1px solid #ccc",
                              padding: 15,
                              marginBottom: 15,
                              borderRadius: 8,
                            }}
                          >
                            <h6 className="mb-3 text-main">
                              {t("common.room")} {index + 1}
                            </h6>
                            <div className="row y-gap-10 justify-between items-center">
                              <div className="col-12">
                                <div className="text-15 fw-500 text-left">
                                  {t("common.adults")}
                                </div>
                                <div className="text-14 lh-12 text-light-1 mt-5">
                                  {t("common.agesFrom")}
                                </div>
                              </div>

                              <div className="col-12">
                                <div className="d-flex justify-content-between items-center js-counter">
                                  <button
                                    className="button -outline-blue-1 text-blue-1 size-38 rounded-4 js-down"
                                    onClick={() => updateRoomAdults(index, -1)} // Corrected
                                    disabled={room.adults <= 1} // Corrected
                                  >
                                    <i className="icon-minus text-12"></i>
                                  </button>

                                  <div className="flex-center size-20 ml-15 mr-15">
                                    <div className="text-15">{room.adults}</div>
                                  </div>

                                  <button
                                    className="button -outline-blue-1 text-blue-1 size-38 rounded-4 js-up"
                                    onClick={() => updateRoomAdults(index, 1)}
                                    disabled={
                                      room.adultNumber + room.childNumber >= 3
                                    }
                                  >
                                    <i className="icon-plus text-12"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="border-top-light mt-10 mb-10"></div>
                            <div className="row y-gap-10 justify-between items-center">
                              <div className="col-12">
                                <div className="text-15 lh-12 fw-500 text-left">
                                  {t("common.children")}
                                </div>
                                <div className="text-14 lh-12 text-light-1 mt-5">
                                  {t("common.agesTo")}
                                </div>
                              </div>

                              <div className="col-12">
                                <div className="d-flex justify-content-between items-center js-counter">
                                  <button
                                    className="button -outline-blue-1 text-blue-1 size-38 rounded-4 js-down"
                                    onClick={() =>
                                      updateRoomChildren(index, -1)
                                    }
                                    disabled={room.children <= 0}
                                  >
                                    <i className="icon-minus text-12"></i>
                                  </button>

                                  <div className="flex-center size-20 ml-15 mr-15">
                                    <div className="text-15">
                                      {room.children}
                                    </div>
                                  </div>

                                  <button
                                    className="button -outline-blue-1 text-blue-1 size-38 rounded-4 js-up"
                                    onClick={() => updateRoomChildren(index, 1)}
                                    disabled={
                                      room.adultNumber + room.childNumber >= 3
                                    }
                                  >
                                    <i className="icon-plus text-12"></i>
                                  </button>
                                </div>
                              </div>

                              {room?.children > 0 && (
                                <div className="col-12 mt-10">
                                  {room?.childAges?.map((age, childIndex) => (
                                    <div
                                      key={childIndex}
                                      className="row y-gap-10 justify-between items-center mt-5"
                                    >
                                      <div className="col-12">
                                        <div className="text-14 lh-12 text-light-1">
                                          {t("common.childAge")}{" "}
                                          {childIndex + 1}
                                        </div>
                                      </div>
                                      <div className="col-12">
                                        <select
                                          value={age}
                                          onChange={(e) =>
                                            handleAgeChange(
                                              index,
                                              childIndex,
                                              parseInt(e.target.value)
                                            )
                                          }
                                          className="form-select text-primary text-14"
                                        >
                                          {[...Array(10)].map((_, i) => (
                                            <option key={i + 2} value={i + 2}>
                                              {i + 2} Years
                                            </option>
                                          ))}{" "}
                                          <option value={12}>
                                            less than 12 Years
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div
                      className="bg-white pb-1 "
                      style={{ borderBottom: `4px solid ${brandColor}` }}
                    >
                      {" "}
                      <Button
                        className="mx-auto  py-2 text-center d-block"
                        onClick={() => setIsActiveGuest(false)}
                      >
                        <FontAwesomeIcon
                          className="mx-2 my-1"
                          icon={faAngleDoubleUp}
                        />
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="button-item">
                  <button
                    style={cursorStyle}
                    className={`mainSearch__submit button -dark-1 h-60 px-35 col-12 rounded-100 bg-blue-1 text-white ${
                      isLoading ? "cursor-not-allowed" : ""
                    }`}
                    onClick={handleSearch}
                    disabled={isLoading}
                  >
                    <i className="icon-search text-20 mr-10"></i>
                    {t("common.search")}
                  </button>
                </div>{" "}
                <Snackbar
                  open={openSnackbar}
                  autoHideDuration={10000}
                  onClose={handleCloseSnackbar}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                  <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                  >
                    {snackbarMessage}
                  </Alert>
                </Snackbar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
